// Estados de un pedido (ver OrderStockService en la API):
// - pendiente: aun sin pagar, no descuenta stock;
// - cancelado: pagado, descuenta el stock y vende las series;
// - anulado: venta anulada, devuelve el stock y libera las series.
export const ORDER_STATUS_LABELS = {
  pendiente: 'Pendiente',
  cancelado: 'Cancelado',
  anulado: 'Anulado',
};

export const ORDER_STATUS_COLORS = {
  pendiente: 'warning',
  cancelado: 'success',
  anulado: 'error',
};

export const orderStatusLabel = (name) => ORDER_STATUS_LABELS[name] || name || '—';
